import { render, staticRenderFns } from "./PanelModalDataEdit.vue?vue&type=template&id=3ebbe887&scoped=true"
import script from "./PanelModalDataEdit.vue?vue&type=script&lang=js"
export * from "./PanelModalDataEdit.vue?vue&type=script&lang=js"
import style0 from "./PanelModalDataEdit.vue?vue&type=style&index=0&id=3ebbe887&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebbe887",
  null
  
)

export default component.exports